import { template_context_value } from '../types';

export function createDefaultTemplateContextValue(): template_context_value {
    // noinspection JSUnusedLocalSymbols
    return { getTemplateComponent: (name: string) => () => null };
}

export default createDefaultTemplateContextValue;
